if (!customElements.get('product-bundle-picker')) {
  customElements.define(
    'product-bundle-picker',
    class ProductBundlePicker extends HTMLElement {
      constructor() {
        super();
        this.options = this.querySelectorAll('.product-bundle__option');
        this.quantityInput = document.getElementById(`Bundle-Quantity-${this.dataset.sectionId}`);
        this.selectedQuantity = parseInt(this.dataset.defaultQty, 10) || 1;

        this.options.forEach((option) => {
          option.addEventListener('click', () => this.#selectOption(option));
        });
      }

      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.sectionId) return;
          this.#updateMainProductPrice();
        });

        this.#updateMainProductPrice();
        this.#syncQuantityInput();
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      #selectOption(option) {
        const quantity = parseInt(option.dataset.quantity, 10);
        if (!quantity || quantity === this.selectedQuantity) return;

        this.selectedQuantity = quantity;
        this.options.forEach((item) => {
          const isSelected = item === option;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });

        this.#syncQuantityInput();
        this.#updateMainProductPrice();
      }

      #getSelectedOptionPrices() {
        const selected = this.querySelector('.product-bundle__option.is-selected');
        if (!selected) return null;

        const priceEl = selected.querySelector('[data-bundle-price]');
        const compareEl = selected.querySelector('[data-bundle-compare]');

        const sale = priceEl?.textContent.trim() || '';
        const compare =
          compareEl && !compareEl.hidden ? compareEl.textContent.trim() : '';

        return { sale, compare };
      }

      #updateMainProductPrice() {
        const priceContainer = document.getElementById(`price-${this.dataset.sectionId}`);
        if (!priceContainer) return;

        const priceEl = priceContainer.querySelector('.price');
        if (!priceEl) return;

        const prices = this.#getSelectedOptionPrices();
        if (!prices?.sale) return;

        const { sale, compare } = prices;
        const showCompare = compare && compare !== sale;

        if (showCompare) {
          priceEl.classList.add('price--on-sale', 'price--bundle-inline');

          const salePriceEl = priceEl.querySelector('.price__sale .price-item--sale');
          const compareEl = priceEl.querySelector('.price__sale s.price-item--regular');

          if (salePriceEl) salePriceEl.textContent = sale;
          if (compareEl) compareEl.textContent = compare;
        } else {
          priceEl.classList.remove('price--on-sale', 'price--bundle-inline');

          const regularPriceEl = priceEl.querySelector('.price__regular > .price-item--regular');
          if (regularPriceEl) regularPriceEl.textContent = sale;
        }
      }

      #syncQuantityInput() {
        if (this.quantityInput) {
          this.quantityInput.value = this.selectedQuantity;
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
  );
}
